import { createSlice } from "@reduxjs/toolkit";

interface AccessManagementTypes {
  sideBarNavigation: any;
  permittedRoutes: string[];
  sideBarItemsLoader: boolean;
}

// initial state
const initialState: AccessManagementTypes = {
  sideBarNavigation: [],
  permittedRoutes: ["/dashboard"],
  sideBarItemsLoader: false,
};

const AccessManagement = createSlice({
  name: "accessManagement",
  initialState,
  reducers: {
    setSideBarNavigation(state, action) {
      state.sideBarNavigation = action.payload;
    },
    setPermittedRoutes(state, action) {
      state.permittedRoutes = ["/dashboard", ...action.payload];
    },
    setSideBarItemsLoader(state, action) {
      state.sideBarItemsLoader = action.payload;
    },
    resetUserAccess(state) {
      state.sideBarNavigation = [];
      state.permittedRoutes = ["/dashboard"];
      state.sideBarItemsLoader = false;
    },
  },
});

export default AccessManagement.reducer;

export const {
  setSideBarNavigation,
  setPermittedRoutes,
  setSideBarItemsLoader,
  resetUserAccess,
} = AccessManagement.actions;
